import { storeManageUrl, storeProviderOf } from '@/lib/billing/storeBilling';

interface PastDueSubscription {
  payment_provider?: string | null;
  store_product_id?: string | null;
}

export type PastDueRecovery =
  | { kind: 'stripe_portal' }
  | { kind: 'pix_invoice' }
  | { kind: 'store_manage'; url: string };

export function resolvePastDueRecovery(
  subscription: PastDueSubscription | null | undefined,
): PastDueRecovery {
  const storeProvider = storeProviderOf(subscription);
  if (storeProvider) {
    return {
      kind: 'store_manage',
      url: storeManageUrl(storeProvider, subscription?.store_product_id),
    };
  }
  if (subscription?.payment_provider === 'stripe') {
    return { kind: 'stripe_portal' };
  }
  return { kind: 'pix_invoice' };
}
